class CategoryTab extends HTMLElement {
    constructor() {
      super();
      this.switchContent = this.switchContent.bind(this);
    }
  
    connectedCallback() {
      this.tabButtons = this.querySelectorAll(".category-tab-content-tab-button");
      this.tabButtons.forEach(tabButton => {
        tabButton.addEventListener("click", () => this.switchContent(tabButton));
      });
  
      // Initialize the first visible slider
      const firstSlider = $(this).find(".category-tab-content-wrapper:not(.hidden) .category-tab-content--image-wrapper");
      if (firstSlider.find(".card-count").length > 2) {
        initializeSlickSlider(firstSlider);
      }
    }
  
    switchContent(clickedTab) {
      const index = clickedTab.getAttribute("data-index");
  
      // Update active tab button
      this.tabButtons.forEach(btn => btn.classList.remove("active-tab-button"));
      clickedTab.classList.add("active-tab-button");
  
      // Hide all content wrappers and unslick sliders
      this.querySelectorAll(".category-tab-content-wrapper").forEach(wrapper => {
        wrapper.classList.add("hidden");
        const content = wrapper.querySelector(".category-tab-content");
        if (content) {
          content.classList.remove("show-content");
          content.classList.add("hide-content");
  
          const $slick = $(content).find(".category-tab-content--image-wrapper");
          if ($slick.hasClass("slick-initialized")) {
            $slick.slick("unslick");
          }
        }
      });
  
      const targetWrapper = this.querySelector(`.category-tab-content-${index}`)?.closest('.category-tab-content-wrapper');
      const targetContent = this.querySelector(`.category-tab-content-${index}`);
  
      if (targetWrapper && targetContent) {
        targetWrapper.classList.remove("hidden");
  
        requestAnimationFrame(() => {
          targetContent.classList.remove("hide-content");
          targetContent.classList.add("show-content");
  
          const $slider = $(targetContent).find(".category-tab-content--image-wrapper");
          if ($slider.find(".card-count").length > 2) {
            initializeSlickSlider($slider);
          }
        });
      }
    }
  }
  
  function initializeSlickSlider($slider) {
    if (!$slider.length) return;
    if (!$slider.hasClass("slick-initialized")) {
      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: `
          <button class="slick-prev" aria-label="Previous slide">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
              <path d="M0 4.1709C0 1.96176 1.79086 0.170898 4 0.170898H28C30.2091 0.170898 32 1.96176 32 4.1709V28.1709C32 30.38 30.2091 32.1709 28 32.1709H4C1.79086 32.1709 0 30.38 0 28.1709V4.1709Z" fill="#EDD2CE"/>
              <path d="M20 24.1709L12 16.1709L20 8.1709" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>`,
        nextArrow: `
          <button class="slick-next" aria-label="Next slide">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
              <path d="M0 4.1709C0 1.96176 1.79086 0.170898 4 0.170898H28C30.2091 0.170898 32 1.96176 32 4.1709V28.1709C32 30.38 30.2091 32.1709 28 32.1709H4C1.79086 32.1709 0 30.38 0 28.1709V4.1709Z" fill="#EDD2CE"/>
              <path d="M12 24.1709L20 16.1709L12 8.1709" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>`,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: true,
              dots: false,
            }
          }
        ]
      });
    }
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    let caseid = getCookie('case_id');
    customElements.define("category-tab", CategoryTab);
  
    const bookacallSection = document.querySelector('.shopify-section.female-testimonial-section');
    const retakeHairtestSection = document.querySelector('.shopify-section.female-retake-test-section');
  
    if (caseid) {
      const rescheduleBtnElement = document.querySelector('.book-slot-button.female-testimonial-button');
      if (rescheduleBtnElement) {
        rescheduleBtnElement.href = `https://form.traya.health/pages/reschedule-slot/${caseid}`;
      }
      bookacallSection?.classList.remove('d-none');
      retakeHairtestSection?.classList.remove('d-none');
    } else {
      bookacallSection?.classList.add('d-none');
      retakeHairtestSection?.classList.add('d-none');
    }
  
    // female hair stories js
    $('.hair-stories-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 1,
      adaptiveHeight: true,
      centerMode: true,
      centerPadding:'0px',
      appendArrows: '.hair-stories-arrows',
      prevArrow: `<button type="button" class="slick-prev">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
          <path d="M0 4.1709C0 1.96176 1.79086 0.170898 4 0.170898H28C30.2091 0.170898 32 1.96176 32 4.1709V28.1709C32 30.38 30.2091 32.1709 28 32.1709H4C1.79086 32.1709 0 30.38 0 28.1709V4.1709Z" fill="#EDD2CE"/>
          <path d="M20 24.1709L12 16.1709L20 8.1709" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>`,
      nextArrow: `<button type="button" class="slick-next">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
          <path d="M32 4.1709C32 1.96176 30.2091 0.170898 28 0.170898H4C1.79086 0.170898 0 1.96176 0 4.1709V28.1709C0 30.38 1.79086 32.1709 4 32.1709H28C30.2091 32.1709 32 30.38 32 28.1709V4.1709Z" fill="#EDD2CE"/>
          <path d="M12 8.1709L20 16.1709L12 24.1709" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>`
    });
    $('.hair-stories-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    // Pause all videos
    document.querySelectorAll('.video-player').forEach(function (video) {
      video.pause();
      video.classList.remove('playing-style');
      video.style.display = 'none';
  
      const vidId = video.getAttribute('id');
      const playBtn = document.querySelector(`.video-overlay-play-button[data-video-id="${vidId}"]`);
      const thumbnail = playBtn?.closest('.video-thumbnail-wrapper')?.querySelector('.video-thumbnail');
      const storyOverlay = playBtn?.closest('.story-card')?.querySelector('.story-overlay');
      const subheadingMobile = document.querySelector('.checkout-subheading-female-mobile');
  
      if (playBtn) playBtn.style.display = 'block';
      if (thumbnail) thumbnail.style.display = 'block';
      if (storyOverlay) storyOverlay.classList.remove('playing-style');
      if (subheadingMobile) {
        subheadingMobile.classList.remove('playing-style');
        subheadingMobile.style.paddingTop = "0px";
      }
    });
  });
    const allVideos = document.querySelectorAll('.video-player');
  
    document.querySelectorAll('.video-overlay-play-button').forEach(function (overlay) {
      overlay.addEventListener('click', function () {
        const videoId = this.getAttribute('data-video-id');
        const video = document.getElementById(videoId);
        const wrapper = this.closest('.video-thumbnail-wrapper');
        const thumbnail = wrapper.querySelector('.video-thumbnail');
        const storyOverlay = wrapper.closest('.story-card').querySelector('.story-overlay');
        const subheadingMobile = document.querySelector('.checkout-subheading-female-mobile');
  
        if (!video) return;
  
        video.style.display = 'block';
        video.play();
        video.classList.add('playing-style');
        if (storyOverlay) storyOverlay.classList.add('playing-style');
        if (subheadingMobile) {
          subheadingMobile.classList.add('playing-style');
          subheadingMobile.style.bottom = "1%"; // ✅ Add padding when playing
        }
  
        this.style.display = 'none';
        if (thumbnail) thumbnail.style.display = 'none';
      });
    });
  
    allVideos.forEach(video => {
      video.addEventListener('play', function () {
        allVideos.forEach(v => {
          if (v !== video) {
            v.pause();
            v.classList.remove('playing-style');
            v.style.display = 'none';
  
            const vidId = v.getAttribute('id');
            const playBtn = document.querySelector(`.video-overlay-play-button[data-video-id="${vidId}"]`);
            const thumb = playBtn?.closest('.video-thumbnail-wrapper')?.querySelector('.video-thumbnail');
            const storyOverlay = playBtn?.closest('.story-card')?.querySelector('.story-overlay');
            const subheadingMobile = document.querySelector('.checkout-subheading-female-mobile');
  
            if (playBtn) playBtn.style.display = 'block';
            if (thumb) thumb.style.display = 'block';
            if (storyOverlay) storyOverlay.classList.remove('playing-style');
            if (subheadingMobile) {
              subheadingMobile.classList.remove('playing-style');
              subheadingMobile.style.paddingTop = "0px"; // ✅ Reset padding when paused
            }
          }
        });
      });
    });
  
    document.querySelectorAll('.video-thumbnail-wrapper').forEach(function (wrapper) {
      wrapper.addEventListener('click', function (e) {
        if (e.target.closest('.video-overlay-play-button')) return;
  
        const video = wrapper.querySelector('.video-player');
        const thumbnail = wrapper.querySelector('.video-thumbnail');
        const playBtn = wrapper.querySelector('.video-overlay-play-button');
        const storyOverlay = wrapper.closest('.story-card').querySelector('.story-overlay');
        const subheadingMobile = document.querySelector('.checkout-subheading-female-mobile');
  
        if (video && !video.paused) {
          video.pause();
          video.classList.remove('playing-style');
          video.style.display = 'none';
  
          if (thumbnail) thumbnail.style.display = 'block';
          if (playBtn) playBtn.style.display = 'block';
          if (storyOverlay) storyOverlay.classList.remove('playing-style');
          if (subheadingMobile) {
            subheadingMobile.classList.remove('playing-style');
            subheadingMobile.style.paddingTop = "0px"; // ✅ Reset on click
          }
        }
      });
    });
  
    // calling page all events 
    const retakeButton = document.querySelector(".female-retake-test--button");
    const stickyBuynowButton = document.querySelector('.testimonial-buy-now-sticky');
    const stickyHairtestButton = document.querySelector('.testimonial-hairtest-sticky');
    const bookACallButtonElement = document.querySelector('a.book-slot-button.female-testimonial-button');
  
    let formattedTime = new Date().toLocaleTimeString();
  
    if (retakeButton) {
      retakeButton.addEventListener('click', function () {
        gtag('event', 'hair-test-started', {
          'send_to': 'G-KJK84KP0LJ',
          'Time': formattedTime
        });
      });
      console.log('Fired event section');
    }
    if(stickyBuynowButton){
      stickyBuynowButton.addEventListener('click', function () {
        gtag('event', 'buy_now_testimonials_page', {
          'send_to': 'G-KJK84KP0LJ',
          'Time': formattedTime
        });
      });
      console.log('Fired event buy');
    }
    if(stickyHairtestButton){
      stickyHairtestButton.addEventListener('click', function () {
        gtag('event', 'hair_test_testimonials_page', {
          'send_to': 'G-KJK84KP0LJ',
          'Time': formattedTime
        });
      });
      console.log('Fired event start');
    }
    if(bookACallButtonElement){
      bookACallButtonElement.addEventListener('click', function () {
        gtag('event', 'book_a_call_testimonials_page', {
          'send_to': 'G-KJK84KP0LJ',
          'Time': formattedTime
        });
      });
      console.log('Fired event book');
    }
    // app code 
    function isApp() {
      const ua = navigator.userAgent.toLowerCase();
      const params = new URLSearchParams(window.location.search);
      return (
        params.get("source") === "app" ||
        ua.includes("shopify mobile") ||
        ua.includes("wv")
      );
    }

    function getCaseIdFromURL() {
      const parts = window.location.pathname.split("/");
      const last = parts.pop();
      return last && last.trim() !== "" ? last : null;
    }

    function debug(msg) {
      const el = document.createElement("h1");
      el.style.fontSize = "16px";
      el.style.padding = "8px";
      el.style.background = "yellow";
      el.style.color = "black";
      el.style.margin = "0";
      el.innerText = msg;
      document.body.prepend(el);
    }

    function showTakeHairTestButton() {
      $(".myresult-stikcy")
        .removeClass("d-inline-block")
        .addClass("d-none")
        .css("display", "none");

      $("#sticky-testbtn")
        .attr("href", "https://form.traya.health/questions?cohort=1&location=stickycta&page=femalev2")
        .removeClass("d-none")
        .css("display", "block");

      // debug("SHOW: Take Hair Test");
    }

    function showBuyNowButton() {
      $(".testimonial-result-stikcy a").each(function () {
        const url = new URL(this.href);
        url.searchParams.set("destination", "result_screen");
        this.href = url.toString();
      });
      $(".myresult-stikcy")
        .removeClass("d-none")
        .addClass("d-inline-block")
        .css("display", "inline-block");

      $(".myresult-stikcy .md-none-d")
        .removeClass("md-none-d")
        .css("display", "inline-block");

      $("#sticky-testbtn")
        .addClass("d-none")
        .css("display", "none");
      const banner = document.querySelector('.real-women-banner-wrapper.banner__buttons');
      if (banner) banner.style.marginTop = 0;

      const header = document.querySelector('sticky-header#myHeader');
      if (header) header.style.display = 'none';

      const footer = document.querySelector('footer#footer .footer-lower');
      if (footer) footer.style.display = 'none';

      const footerBackground = document.querySelector('footer#footer');
      if (footerBackground) footerBackground.style.background = 'none';
      // debug("SHOW: BUY NOW ✔️");
    }

    (async function () {
      if (!isApp()) {
        // debug("NOT APP ❌");
        return;
      }

      // debug("APP DETECTED ✔️");

      const caseId = getCaseIdFromURL();
      // debug("CASE ID: " + (caseId || "NONE"));

      // Book a call + retake sections
      const bookacallSection = document.querySelector('.shopify-section.female-testimonial-section');
      // const retakeHairtestSection = document.querySelector('.shopify-section.female-retake-test-section');

      if (!caseId) {
        // No Case ID → Only show Take Test
        showTakeHairTestButton();

        bookacallSection?.classList.add('d-none');
        // retakeHairtestSection?.classList.add('d-none');

        return;
      }

      // Case ID present → Show Buy Now
      showBuyNowButton();

      bookacallSection?.classList.remove('d-none');
      // retakeHairtestSection?.classList.remove('d-none');

      // Update reschedule URL
      const rescheduleBtn = document.querySelector('.book-slot-button.female-testimonial-button');
      if (rescheduleBtn) {
        rescheduleBtn.href = `https://form.traya.health/pages/reschedule-slot/${caseId}`;
      }
      const btn = document.querySelector(".book-slot-button.female-retake-test--button");
      if (btn) {
        const url = new URL(btn.href, window.location.origin);
        url.searchParams.set("destination", "hair_test");
        btn.href = url.toString();
      }
      // Final override — fix any theme scripts that try to hide it
      setTimeout(() => {
        $(".myresult-stikcy")
          .removeClass("d-none")
          .addClass("d-inline-block")
          .css("display", "inline-block");

        $("#sticky-testbtn")
          .addClass("d-none")
          .css("display", "none");

        // debug("FINAL FORCE FIX APPLIED ✔️");
      }, 600);

    })();

  });